import * as Colors from '@brightlayer-ui/colors';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StatusGaugeCard } from '../../components/StatusGaugeCard';
import { Status as SubscriptionStatus, Tier } from '../../services/subscription/types';

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        width: '98.5%',
    },
    contentBox: {
        display: 'flex',
        flex: '1 0 auto',
        flexDirection: 'column',
        margin: '32px 32px 0px 32px',
        padding: '32px',
        backgroundColor: Colors.white[50],
    },
    headerSection: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
    },
};

type FreeSubscriptionDetailsProps = {
    organizationName: string;
    subscriptionStatus: SubscriptionStatus;
    subscriptionTier: Tier;
    deviceLimit: number;
    currentDeviceCount: number;
    rateLimit: number;
    statusGaugeColor: string;
};

export const FreeSubscriptionDetails: React.FC<FreeSubscriptionDetailsProps> = (props) => {
    const {
        organizationName,
        subscriptionStatus,
        deviceLimit,
        currentDeviceCount,
        rateLimit,
        subscriptionTier,
        statusGaugeColor,
    } = props;

    const { t } = useTranslation();

    return (
        <Box sx={styles.container}>
            <Box sx={styles.contentBox}>
                <Box sx={styles.headerSection}>
                    <Box>
                        <Typography color={Colors.gray[800]} variant="h6" sx={{ marginBottom: '8px' }}>
                            {organizationName} {t('SUBSCRIPTION_DETAILS_PAGE.LICENSE_DETAILS')}
                        </Typography>
                        <Typography color={Colors.gray[700]} variant="subtitle2" sx={{ marginBottom: '8px' }}>
                            <b>{t('FREE_TIER_SUBSCRIPTION.CURRENT_DEVICES_COMMISSIONED')}: </b>
                            {currentDeviceCount}
                        </Typography>
                        <Typography color={Colors.gray[700]} variant="subtitle2" sx={{ marginBottom: '8px' }}>
                            <b>{t('FREE_TIER_SUBSCRIPTION.DEVICE_LIMIT')}: </b>
                            {deviceLimit}
                        </Typography>
                        <Typography color={Colors.gray[700]} variant="subtitle2" sx={{ marginBottom: '8px' }}>
                            <b>{t('FREE_TIER_SUBSCRIPTION.API_RATE_LIMIT')}: </b>
                            {rateLimit} {t('FREE_TIER_SUBSCRIPTION.REQUESTS_PER_HOUR')}
                        </Typography>
                    </Box>

                    <StatusGaugeCard
                        data-testid="subscription-status-card"
                        title={t('ORGANIZATION_DETAILS_PAGE.TIER')}
                        status={subscriptionStatus}
                        subtitle1={subscriptionTier}
                        color={statusGaugeColor}
                    />
                </Box>
            </Box>
        </Box>
    );
};
